




import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {DateTime} from 'luxon';
import axios from 'axios';
import {getBaseURL, nil} from '@/common';
import FileDownload from 'js-file-download';
import LoadingDialog from '@/components/Views/UI/LoadingDialog.vue';

@Component({
    components: {LoadingDialog},
})
export default class ExportDialog extends Vue {
    @Prop({default: () => []})
    public items!: any[];
    public open = false;

    @Watch('open')
    public onOpenChanged(value: boolean, oldValue: boolean) {
        if (value) {
            (this.$refs.loadingDialog as any).open = true;
            this.downloadExport();
        }
    }

    public created() {
        this.init();
    }

    public async init() {
    }

    public cancelClicked() {

    }

    get headers(): string[] {
        if (nil(this.items) || this.items.length === 0) {
            return [];
        }
        return Object.keys(this.items[0]);
    }

    public async downloadExport() {
        const {Download} = this.$FeathersVuex;
        const data = {content: this.items, total: this.items.length};
        const newExport = new Download(data);
        await newExport.create();
        const createdId = this.$store.state.downloads.currentId;
        const response = await axios.get(`${getBaseURL()}/downloads/${createdId}`, {
            headers: {Authorization: `Bearer ${this.$store.state.auth.accessToken}`},
        });
        FileDownload(response.data, 'export.csv');
        (this.$refs.loadingDialog as any).open = false;
        /*console.log(`id is ${createdId}`);
        const createdExport = await Download.get(createdId);
        debugger;*/
        // this.exporting = true;
        // let data =
        // this.$store.dispatch('downloads/create', data);
        // this.exporting = false;
    }

    public friendlyDate(iso: string): string {
        return DateTime.fromISO(iso).toLocal().toLocaleString(DateTime.DATETIME_MED) || 'unknown time';
    }
}
